import { Typography } from "@mui/material";
import React, { useState } from "react";

export const MonthlyReportKeyHighlights = ({ data, month }) => {
  const [top3Courses] = useState(
    data.course_wise_report.slice(0, 3)
  );

  return (
    <div className="key-highlights-report-container mt-4">
      <Typography sx={{ fontWeight: "bold" }} variant="body1">
        Key Highlights:
      </Typography>
      <ol type="A">
        <li>
          <Typography>
            <strong>No of Schools</strong> = {data.total_schools} with{" "}
            {data.total_smart_class} smart classes operational. Aveti econtent
            is used by {data.total_teachers} trained teachers. Each school has 2
            classrooms on average.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Video Engagement</strong>
          </Typography>
          <ul>
            <li className="arrow-li">
              Cummulative video usage : {Math.ceil(data.total_video_usage)}{" "}
              Hours
            </li>
            <li className="arrow-li">
              Average usage in current month by all schools :{" "}
              {Math.ceil(
                (data.total_video_usage - data.previous_month_video_usage) /
                  data.total_schools
              )}{" "}
              Hours
            </li>
          </ul>
        </li>
        <li>
          <Typography>
            <strong>Assessment Engagement</strong>
          </Typography>
          <ul>
            <li>
              Cummulative assessment usage :{" "}
              {Math.ceil(data.total_exercise_usage)}
              {" Hours"}
            </li>
            <li className="arrow-li">
              Average usage in current month by all schools :{" "}
              {Math.ceil(
                (data.total_exercise_usage -
                  data.previous_month_exercise_usage) /
                  data.total_schools
              )}{" "}
              Hour(s)
            </li>
          </ul>
        </li>
        <li>
          <Typography>
            <strong>
              Total Content Usage(Video+Exercise) in the Current Cycle
            </strong>
          </Typography>
          <ul>
            <li>
              Average usage {">"} 30 hours/month engagement by{" "}
              {data.more_than_30_hours_usage.school_count} schools (
              {data.more_than_30_hours_usage.percentage}% of total)
            </li>
            <li>
              Average usage 10 to 30 hours/month engagement by{" "}
              {data.between_10_to_30_hours_schools.school_count} schools (
              {data.between_10_to_30_hours_schools.percentage}% of total)
            </li>
            <li>
              More details in <span>Appendix A</span>
            </li>
          </ul>
        </li>
        <li>
          <Typography>
            <strong>Courses</strong>
          </Typography>
          <ul>
            <li>
              {data.course_wise_report.length} courses are currently being used
              by {data.total_schools} schools.
            </li>
            <li>Top high-engagement course of this month: -</li>
            <ul>
              {top3Courses.map((course) => {
                return (
                  <li key={course.crs_id}>
                    <Typography sx={{ display: "flex", alignItems: "center" }}>
                      {course.crs_title} :{" "}
                      {Math.ceil(course.view_time_in_hours)} Hours
                    </Typography>
                  </li>
                );
              })}
            </ul>
          </ul>
        </li>
      </ol>
    </div>
  );
};
